export default __webpack_public_path__ + "img/b069b0de78adb886f3f353e2f339ca67.png";